export default __webpack_public_path__ + "static/media/element1.12d94c7c.svg";